import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Dropdown from '../molecules/Dropdown';
import { generateArrayOfSize } from '../../global/utils';
import { TOP_X_COUNT_MAX_VALUE } from './PivotChart/consts';
import css from './TopXChartDataFilter.css';

export const SHOW_ALL = 'All';

const TopxChartDataFilter = ({ topXCount, rowDataLength, onChange, withShowAll, className, labelClassName, dropdownClassName, disabled = false }) => {
    const items = [
        ...generateArrayOfSize(Math.min(TOP_X_COUNT_MAX_VALUE, rowDataLength)).map(i => ({
            name: i + 1,
            display_name: i + 1,
        })),
        ...(withShowAll ? [{ name: SHOW_ALL, display_name: SHOW_ALL }] : []),
    ];

    return (
        <div className={classNames(css.topXContainer, className)}>
            <span className={classNames(css.topXLabel, labelClassName)}>
                <Translate id="STATIC.SHOW_CHART_TOP_ROWS5" />:
            </span>
            <Dropdown
                containerClass={css.topXDropdownContainer}
                selectedContainer={dropdownClassName}
                selected={{ name: topXCount, display_name: topXCount }}
                onSelection={({ name }) => {
                    onChange(name);
                }}
                items={items}
                disabled={disabled}
            />
        </div>
    );
};
TopxChartDataFilter.propTypes = {
    topXCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    rowDataLength: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    withShowAll: PropTypes.bool,
    className: PropTypes.string,
    labelClassName: PropTypes.string,
    dropdownClassName: PropTypes.string,
    disabled: PropTypes.bool,
};

export default TopxChartDataFilter;
